import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_URL } from "../../app.config";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { editLedderLetterDataApiCall } from "../../Store/slices/ladderLetterSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import { IoMdArrowRoundBack } from "react-icons/io";
import {
  convertToBase64,
  TOAST_ERROR,
  NUMBER_VALIDATION,
} from "../../utils/common.service";
import * as API from "../../utils/api.service";

export default function EditLatter() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const clientData = location?.state?.clientData;
  const [categories, setCategories] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [logoPng, setLogoPng] = useState(null);
  const [letterPng, setLetterPng] = useState(null);
  //const [backgroundPng, setBackgroundPng] = useState(null);

  // State for profile images
  const [logoImageState, setLogoImageState] = useState(
    PUBLIC_URL + "/assets/images/default_logo.jpg"
  );
  const [letterImageState, setLetterImageState] = useState(
    PUBLIC_URL + "/assets/images/default_letter.jpg"
  );
  // const [backgroundImageState, setBackgroundImageState] = useState(
  //   PUBLIC_URL + "/assets/images/default_background.jpg"
  // );
  const [isFree, setIsFree] = useState(clientData?.is_free);
  // console.log(
  //   "9999999999999999999999999999999999999999999999999999",
  //   clientData?.is_free
  // );

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await API.getCategaryListApi();
        
        setCategories(response.data);
      } catch (error) {
        TOAST_ERROR("Failed to load categories");
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (clientData) {
      setLogoImageState(clientData?.logo);
      setLetterImageState(clientData?.latter_image);
      //setBackgroundImageState(clientData?.background_image);
      setIsFree(clientData?.is_free || "false");
      reset({
        logoImage: clientData?.logo_name,
        letterImage: clientData?.letter_name,
        // backgroundImage: clientData?.background_image_name,
        skip_point: clientData?.skip_point ?? "",
        description: clientData?.description ?? "",
        ar_description: clientData?.ar_description ?? "",
        points: clientData?.points ?? "",
        category: clientData?.category ?? "",
        total_used_line: clientData?.total_used_line,
      });
    }
  }, [clientData, reset]);

  const convertToPNG = async (blob) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        canvas.toBlob((pngBlob) => {
          resolve(pngBlob);
        }, "image/png");
      };

      img.onerror = reject;
      img.src = URL.createObjectURL(blob);
    });
  };

  const handleImageChange = async (image, field) => {
    try {
      if (image && image.size / 1024 > 3072) {
        TOAST_ERROR("Please select an image smaller than 3MB");
        return;
      }

      const bufferImage = await convertToBase64(image);
      setValue(field, image);

      switch (field) {
        case "logoImage":
          setLogoImageState(bufferImage);
          setLogoPng(await convertToPNG(image));
          break;
        case "letterImage":
          setLetterImageState(bufferImage);
          setLetterPng(await convertToPNG(image));
          break;
        // case "backgroundImage":
        //   setBackgroundImageState(bufferImage);
        //   setBackgroundPng(await convertToPNG(image));
        //   break;
        default:
          break;
      }
      clearErrors(field);
    } catch (e) {
      console.log("Image change error:", e);
    }
  };

 
  const onSubmit = async (submitData) => {
    dispatch(setLoader(true));
    try {
      let requestBody = {
        id: clientData?.id,
        logo: submitData.logoImage,
        latter_image: submitData.letterImage,
        //background_image: submitData.backgroundImage,
        is_free: isFree,
        skip_point: submitData.skip_point,
        description: submitData.description,
        ar_description: submitData.ar_description,
        points: submitData.points,
        category: submitData.category,
        total_used_line: submitData.total_used_line,
      };

      // Mapping fields to be uploaded
      const imageFieldMapping = {
        logoImage: "logo",
        letterImage: "latter_image",
        //backgroundImage: "background_image",
      };

      // Upload original images
      // for (const field of ["logoImage", "letterImage", "backgroundImage"]) {
      //   let image = submitData[field];
      //   if (image instanceof Blob) {
      //     const uploadedImageUrl = await uploadImageOnAWS(image, "letter");
      //     requestBody[imageFieldMapping[field]] = uploadedImageUrl;
      //   }
      // }

      for (const field of ["logoImage", "letterImage"]) {
        let image = submitData[field];
        if (image instanceof Blob) {
          const uploadedImageUrl = await uploadImageOnAWS(image, "ladder_letter");
          requestBody[imageFieldMapping[field]] = uploadedImageUrl;
        }
      }

      // Upload PNG versions of images if they exist
      const pngFieldMapping = {
        logoPng: "png_logo",
        letterPng: "png_latter_image",
        //backgroundPng: "png_background_image",
      };

      for (const [pngField, pngKey] of Object.entries(pngFieldMapping)) {
        if (pngField === "logoPng" && logoPng) {
          const pngUrl = await uploadImageOnAWS(logoPng, "ladder_letter");
          requestBody[pngKey] = pngUrl;
        } else if (pngField === "letterPng" && letterPng) {
          const pngUrl = await uploadImageOnAWS(letterPng, "ladder_letter");
          requestBody[pngKey] = pngUrl;
        }
        // else if (pngField === "backgroundPng" && backgroundPng) {
        //   const pngUrl = await uploadImageOnAWS(backgroundPng, "letter");
        //   requestBody[pngKey] = pngUrl;
        // }
      }

      // Dispatch the API call to update letter data
      await dispatch(editLedderLetterDataApiCall(requestBody));

      // Navigate back to manage letter page
      navigate(`/manage_ladder_letter`);
      reset();
    } catch (err) {
      TOAST_ERROR(err.message);
    } finally {
      dispatch(setLoader(false));
    }
  };
  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title={`Edit Ladder`}
            header={`ladder`}
            subHeader={`Edit Ladder`}
          />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <IoMdArrowRoundBack fontSize={"20px"}/>
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  {/* Logo Image */}
                  <div className="col-md-6 d-flex justify-content-center mb-3">
                    <Controller
                      name="logoImage"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={logoImageState}
                            alt="logo image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                          <label htmlFor="logoImage">
                            <div className="upload-document mt-2">
                              <div className="btn btn-outline-info m-1">
                                Choose Logo Image
                              </div>
                            </div>
                          </label>
                        </div>
                      )}
                    />
                    <input
                      type="file"
                      name="files[]"
                      id="logoImage"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleImageChange(e.target.files[0], "logoImage")
                      }
                      accept="image/svg+xml"
                    />
                  </div>

                  {/* Letter Image */}
                  <div className="col-md-6 d-flex justify-content-center mb-3">
                    <Controller
                      name="letterImage"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={letterImageState}
                            alt="letter image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                          <label htmlFor="letterImage">
                            <div className="upload-document mt-2">
                              <div className="btn btn-outline-info m-1">
                                Choose Letter Image
                              </div>
                            </div>
                          </label>
                        </div>
                      )}
                    />
                    <input
                      type="file"
                      name="files[]"
                      id="letterImage"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleImageChange(e.target.files[0], "letterImage")
                      }
                      accept="image/svg+xml"
                    />
                  </div>

                  {/* Background Image */}
                  {/* <div className="col-md-4 d-flex justify-content-center mb-3">
                    <Controller
                      name="backgroundImage"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={backgroundImageState}
                            alt="background image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                          <label htmlFor="backgroundImage">
                            <div className="upload-document mt-2">
                              <div className="btn btn-outline-info m-1">
                                Choose Background Image
                              </div>
                            </div>
                          </label>
                        </div>
                      )}
                    />
                    <input
                      type="file"
                      name="files[]"
                      id="backgroundImage"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleImageChange(e.target.files[0], "backgroundImage")
                      }
                      accept="image/svg+xml"
                    />
                  </div> */}
                </div>

                {/* Toggle Button for is_free */}
                <div className="mb-3 d-flex align-items-center">
                  <label className="form-label mb-0 me-2">Is Free:</label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isFree"
                      checked={isFree === "true"}
                      onChange={(e) =>
                        setIsFree(e.target.checked ? "true" : "false")
                      }
                    />
                  </div>
                </div>

                <div className="row">
                  {/* Points Input */}
                  <div className="mb-3 col-4">
                    <label className="form-label">Points</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("points", NUMBER_VALIDATION("points"))}aria-invalid={errors.email ? "true" : "false"}
                      defaultValue={clientData?.points || ""}
                      placeholder="Enter points"
                    />
                    <div className="errorc">{errors.points?.message}</div>
                  </div>

                  {/* Skip Point Input */}
                  <div className="mb-3 col-4">
                    <label className="form-label">Skip Path</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("skip_point",NUMBER_VALIDATION("skip points"))}aria-invalid={errors.email ? "true" : "false"}
                      defaultValue={clientData?.skip_point || ""}
                      placeholder="Enter skip point"
                      />
                    <div className="errorc">{errors.skip_point?.message}</div>
                    
                  </div>

                  <div className="mb-3 col-4">
                    <label className="form-label">Total Line</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("total_used_line", NUMBER_VALIDATION("total line"))}aria-invalid={errors.email ? "true" : "false"}
                      defaultValue={clientData?.total_used_line || ""}
                      placeholder="Enter Total point"
                    />
                    <div className="errorc">
                      {errors.total_used_line?.message}
                    </div>
                  </div>

                  {/* Category Dropdown */}
                  {/* <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="category" className="form-label">
                        Category
                      </label>
                      <select
                        id="category"
                        className="form-control"
                        {...register("category", {
                          required: "Category is required",
                        })}
                        defaultValue={clientData?.category || "category1"}
                      >
                        <option value="">Select Category</option>
                        {categories?.map((category) => (
                          <option
                            key={category.id}
                            value={category.id}
                            selected={
                              parseInt(clientData?.category) == category?.id
                            }
                          >
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="errorc">{errors.category?.message}</div>
                  </div> */}
                </div>
                <div className="row">
                  {/* Description Input */}
                  <div className="mb-3 col-12">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      {...register("description")}
                      defaultValue={clientData?.description || ""}
                      placeholder="Enter description"
                    />
                    <div className="errorc">{errors.description?.message}</div>
                  </div>

                  <div className="mb-3 col-12">
                    <label className="form-label">Description(Arabic)</label>
                    <textarea
                      className="form-control"
                      {...register("ar_description")}
                      defaultValue={clientData?.ar_description || ""}
                      placeholder="Enter description"
                    />
                    <div className="errorc">{errors.ar_description?.message}</div>
                  </div>
                </div>

                <div className="mb-0 text-center">
                  <button className="btn btn-soft-primary w-25" type="submit">
                    <i className="ri-save-fill"></i>{" "}
                    <span className="fw-bold">Update</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
